import React from "react";
import { MessageSquare } from "lucide-react";

const FeedbackIcon = (props: any) => <MessageSquare {...props} />;

export default FeedbackIcon;
